import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './BrandIconCard.module.css';

const HAMBURGER = 'hamburger';
const PLUS = 'plus';
const MINUS = 'minus';
const CROSS = 'cross';
const LINK = 'link';
const BED = 'bed';
const DOWNARROW = 'downarrow';
const UPARROW = 'uparrow';
const ROUNDPLUS = 'roundplus';
const ROUNDMINUS = 'roundminus';
const CAR = 'car';
const UNFILLEDHEART = 'unfilledheart';
const FILLEDHEART = 'filledheart';

const BrandIconCard = props => {
  const { className, rootClassName, type } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (type) {
    case ROUNDMINUS:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 11H16.5M19.9375 11C19.9375 13.3704 18.9959 15.6437 17.3198 17.3198C15.6437 18.9959 13.3704 19.9375 11 19.9375C8.62963 19.9375 6.35634 18.9959 4.68023 17.3198C3.00413 15.6437 2.0625 13.3704 2.0625 11C2.0625 8.62963 3.00413 6.35634 4.68023 4.68023C6.35634 3.00413 8.62963 2.0625 11 2.0625C13.3704 2.0625 15.6437 3.00413 17.3198 4.68023C18.9959 6.35634 19.9375 8.62963 19.9375 11Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      );
    case ROUNDPLUS:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 11H16.5" // Horizontal line for the plus
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M11 5.5V16.5" // Vertical line for the plus
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M19.9375 11C19.9375 13.3704 18.9959 15.6437 17.3198 17.3198C15.6437 18.9959 13.3704 19.9375 11 19.9375C8.62963 19.9375 6.35634 18.9959 4.68023 17.3198C3.00413 15.6437 2.0625 13.3704 2.0625 11C2.0625 8.62963 3.00413 6.35634 4.68023 4.68023C6.35634 3.00413 8.62963 2.0625 11 2.0625C13.3704 2.0625 15.6437 3.00413 17.3198 4.68023C18.9959 6.35634 19.9375 8.62963 19.9375 11Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      );

    case UPARROW:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.897 7.22197L3.19 13.92C3.12489 13.9854 3.0473 14.0371 2.96184 14.0721C2.87638 14.107 2.78478 14.1244 2.69246 14.1233C2.60015 14.1222 2.50899 14.1025 2.4244 14.0656C2.33981 14.0286 2.26351 13.975 2.2 13.908C2.06989 13.7709 1.99835 13.5885 2.00059 13.3995C2.00284 13.2106 2.07868 13.0299 2.212 12.896L9.415 5.70297C9.47963 5.6379 9.55658 5.58637 9.64136 5.55138C9.72614 5.5164 9.81705 5.49867 9.90876 5.49923C10.0005 5.49979 10.0911 5.51862 10.1755 5.55464C10.2598 5.59065 10.3362 5.64312 10.4 5.70897L17.795 13.28C17.9259 13.4155 17.999 13.5966 17.999 13.785C17.999 13.9734 17.9259 14.1544 17.795 14.29C17.7307 14.3562 17.6537 14.4088 17.5687 14.4448C17.4837 14.4807 17.3923 14.4993 17.3 14.4993C17.2077 14.4993 17.1163 14.4807 17.0313 14.4448C16.9463 14.4088 16.8693 14.3562 16.805 14.29L9.897 7.22197Z"
            fill="black"
          />
        </svg>
      );
    case DOWNARROW:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.103 12.778L16.81 6.08003C16.8751 6.01458 16.9527 5.96286 17.0382 5.92793C17.1236 5.89301 17.2152 5.87559 17.3075 5.87671C17.3999 5.87783 17.491 5.89746 17.5756 5.93445C17.6602 5.97143 17.7365 6.02502 17.8 6.09203C17.9301 6.2291 18.0016 6.41149 17.9994 6.60047C17.9972 6.78944 17.9213 6.97009 17.788 7.10403L10.585 14.297C10.5204 14.3621 10.4434 14.4136 10.3586 14.4486C10.2739 14.4836 10.183 14.5013 10.0912 14.5008C9.99953 14.5002 9.90885 14.4814 9.8245 14.4454C9.74016 14.4094 9.66383 14.3569 9.6 14.291L2.205 6.72003C2.07412 6.58449 2.00098 6.40344 2.00098 6.21503C2.00098 6.02662 2.07412 5.84557 2.205 5.71003C2.26931 5.6438 2.34626 5.59116 2.43129 5.55521C2.51631 5.51926 2.60769 5.50073 2.7 5.50073C2.79231 5.50073 2.88369 5.51926 2.96872 5.55521C3.05374 5.59116 3.13069 5.6438 3.195 5.71003L10.103 12.778Z"
            fill="black"
          />
        </svg>
      );
    case BED:
      return (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.90625 7.125H10.0938V6.53125C10.0938 6.37378 10.1563 6.22276 10.2677 6.11141C10.379 6.00006 10.53 5.9375 10.6875 5.9375H12.4688C12.6262 5.9375 12.7772 6.00006 12.8886 6.11141C12.9999 6.22276 13.0625 6.37378 13.0625 6.53125V7.125H15.4375V4.75C15.4375 4.12011 15.1873 3.51602 14.7419 3.07062C14.2965 2.62522 13.6924 2.375 13.0625 2.375H5.9375C5.30761 2.375 4.70352 2.62522 4.25812 3.07062C3.81272 3.51602 3.5625 4.12011 3.5625 4.75V7.125H5.9375V6.53125C5.9375 6.37378 6.00006 6.22276 6.11141 6.11141C6.22275 6.00006 6.37378 5.9375 6.53125 5.9375H8.3125C8.46997 5.9375 8.621 6.00006 8.73234 6.11141C8.84369 6.22276 8.90625 6.37378 8.90625 6.53125V7.125ZM4.15625 8.3125C3.36889 8.3125 2.61378 8.62528 2.05703 9.18203C1.50028 9.73878 1.1875 10.4939 1.1875 11.2812V16.0312C1.1875 16.1887 1.25006 16.3397 1.36141 16.4511C1.47276 16.5624 1.62378 16.625 1.78125 16.625C1.93872 16.625 2.08974 16.5624 2.20109 16.4511C2.31244 16.3397 2.375 16.1887 2.375 16.0312V13.0625H16.625V16.0312C16.625 16.1887 16.6876 16.3397 16.7989 16.4511C16.9103 16.5624 17.0613 16.625 17.2188 16.625C17.3762 16.625 17.5272 16.5624 17.6386 16.4511C17.7499 16.3397 17.8125 16.1887 17.8125 16.0312V11.2812C17.8125 10.4939 17.4997 9.73878 16.943 9.18203C16.3862 8.62528 15.6311 8.3125 14.8438 8.3125H4.15625Z"
            fill="#712739"
          />
        </svg>
      );
    case LINK:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m0.25 0.439 -0.044 0.043a0.062 0.062 0 0 1 -0.088 -0.088l0.114 -0.114a0.061 0.061 0 0 1 0.085 -0.002l0.003 0.003a0.025 0.025 0 0 0 0.035 -0.036 0.075 0.075 0 0 0 -0.004 -0.005 0.112 0.112 0 0 0 -0.152 0.006l-0.115 0.114a0.112 0.112 0 0 0 0.158 0.158L0.284 0.475A0.025 0.025 0 0 0 0.25 0.439M0.517 0.083a0.112 0.112 0 0 0 -0.158 0L0.316 0.125A0.025 0.025 0 0 0 0.35 0.161l0.043 -0.043a0.062 0.062 0 0 1 0.088 0.088l-0.114 0.114a0.061 0.061 0 0 1 -0.085 0.002l-0.003 -0.003a0.025 0.025 0 0 0 -0.035 0.036 0.075 0.075 0 0 0 0.006 0.005 0.112 0.112 0 0 0 0.152 -0.006l0.114 -0.114a0.112 0.112 0 0 0 0.001 -0.158" />
        </svg>
      );
    case CROSS:
      return (
        <svg
          fill="#000000"
          width="40px"
          height="40px"
          viewBox="0 0 1.2 1.2"
          data-name="Flat Color"
        >
          <path
            id="primary"
            d="m0.671 0.6 0.315 -0.315a0.05 0.05 0 1 0 -0.071 -0.071L0.6 0.529l-0.315 -0.315a0.05 0.05 0 0 0 -0.071 0.071l0.315 0.315 -0.315 0.315a0.05 0.05 0 0 0 0 0.071 0.05 0.05 0 0 0 0.071 0l0.315 -0.315 0.315 0.315a0.05 0.05 0 0 0 0.071 0 0.05 0.05 0 0 0 0 -0.071Z"
          />
        </svg>
      );
    case MINUS:
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8663 0.750009L8.23105 8.23152M8.23105 8.23152L1.59577 15.713M8.23105 8.23152L0.74954 1.59624M8.23105 8.23152L15.7126 14.8668"
            stroke="#712739"
            stroke-width="1.5"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PLUS:
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.75 10.75H10.75M10.75 10.75H0.75M10.75 10.75V0.75M10.75 10.75V20.75"
            stroke="#712739"
            stroke-width="1.5"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case HAMBURGER:
      return (
        <svg
          className={classes}
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.25 9.75C3.25 9.31902 3.4212 8.9057 3.72595 8.60095C4.0307 8.29621 4.44402 8.125 4.875 8.125H34.125C34.556 8.125 34.9693 8.29621 35.274 8.60095C35.5788 8.9057 35.75 9.31902 35.75 9.75C35.75 10.181 35.5788 10.5943 35.274 10.899C34.9693 11.2038 34.556 11.375 34.125 11.375H4.875C4.44402 11.375 4.0307 11.2038 3.72595 10.899C3.4212 10.5943 3.25 10.181 3.25 9.75ZM3.25 19.552C3.25 19.121 3.4212 18.7077 3.72595 18.403C4.0307 18.0982 4.44402 17.927 4.875 17.927H34.125C34.556 17.927 34.9693 18.0982 35.274 18.403C35.5788 18.7077 35.75 19.121 35.75 19.552C35.75 19.983 35.5788 20.3963 35.274 20.701C34.9693 21.0058 34.556 21.177 34.125 21.177H4.875C4.44402 21.177 4.0307 21.0058 3.72595 20.701C3.4212 20.3963 3.25 19.983 3.25 19.552ZM4.875 27.7306C4.44402 27.7306 4.0307 27.9018 3.72595 28.2066C3.4212 28.5113 3.25 28.9246 3.25 29.3556C3.25 29.7866 3.4212 30.1999 3.72595 30.5047C4.0307 30.8094 4.44402 30.9806 4.875 30.9806H34.125C34.556 30.9806 34.9693 30.8094 35.274 30.5047C35.5788 30.1999 35.75 29.7866 35.75 29.3556C35.75 28.9246 35.5788 28.5113 35.274 28.2066C34.9693 27.9018 34.556 27.7306 34.125 27.7306H4.875Z"
            fill="#363B3E"
          />
        </svg>
      );
    case CAR:
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.7935 3.5C14.2809 3.50002 14.7587 3.63574 15.1733 3.89197C15.588 4.1482 15.9231 4.51482 16.1411 4.95075L17.3539 7.37537C17.5674 7.28787 17.7774 7.19337 17.9839 7.09187C18.1916 6.98814 18.432 6.97117 18.6522 7.04468C18.8724 7.11819 19.0544 7.27618 19.1581 7.48388C19.2619 7.69157 19.2788 7.93197 19.2053 8.15219C19.1318 8.3724 18.9738 8.55439 18.7661 8.65813C18.5558 8.75173 18.3443 8.84274 18.1318 8.93112L18.9726 10.6137C19.1551 10.9786 19.2501 11.3809 19.25 11.7889V14C19.25 14.3693 19.1721 14.7345 19.0213 15.0716C18.8705 15.4088 18.6503 15.7103 18.375 15.9565V17.0625C18.375 17.4106 18.2367 17.7444 17.9906 17.9906C17.7444 18.2367 17.4106 18.375 17.0625 18.375C16.7144 18.375 16.3806 18.2367 16.1344 17.9906C15.8883 17.7444 15.75 17.4106 15.75 17.0625V16.625H5.25V17.0625C5.25 17.4106 5.11172 17.7444 4.86558 17.9906C4.61944 18.2367 4.2856 18.375 3.9375 18.375C3.5894 18.375 3.25556 18.2367 3.00942 17.9906C2.76328 17.7444 2.625 17.4106 2.625 17.0625V15.9565C2.08775 15.4753 1.75 14.777 1.75 14V11.788C1.75016 11.3807 1.84513 10.9789 2.02737 10.6146L2.86125 8.94512C2.65008 8.85646 2.44154 8.76108 2.23563 8.659C2.02898 8.55392 1.8719 8.37184 1.79824 8.15202C1.72459 7.93221 1.74026 7.69225 1.84188 7.48388C1.8932 7.381 1.9643 7.28925 2.0511 7.21386C2.13791 7.13848 2.23871 7.08094 2.34777 7.04454C2.45682 7.00813 2.57198 6.99357 2.68666 7.0017C2.80134 7.00982 2.91329 7.04046 3.01613 7.09187C3.22321 7.19396 3.43321 7.28846 3.64612 7.37537L4.85888 4.95162C5.07679 4.51553 5.41185 4.14874 5.82649 3.89235C6.24114 3.63595 6.71899 3.5001 7.2065 3.5H13.7935ZM6.5625 11.375C6.2144 11.375 5.88056 11.5133 5.63442 11.7594C5.38828 12.0056 5.25 12.3394 5.25 12.6875C5.25 13.0356 5.38828 13.3694 5.63442 13.6156C5.88056 13.8617 6.2144 14 6.5625 14C6.9106 14 7.24444 13.8617 7.49058 13.6156C7.73672 13.3694 7.875 13.0356 7.875 12.6875C7.875 12.3394 7.73672 12.0056 7.49058 11.7594C7.24444 11.5133 6.9106 11.375 6.5625 11.375ZM14.4375 11.375C14.0894 11.375 13.7556 11.5133 13.5094 11.7594C13.2633 12.0056 13.125 12.3394 13.125 12.6875C13.125 13.0356 13.2633 13.3694 13.5094 13.6156C13.7556 13.8617 14.0894 14 14.4375 14C14.7856 14 15.1194 13.8617 15.3656 13.6156C15.6117 13.3694 15.75 13.0356 15.75 12.6875C15.75 12.3394 15.6117 12.0056 15.3656 11.7594C15.1194 11.5133 14.7856 11.375 14.4375 11.375ZM13.7935 5.25H7.2065C7.06248 5.24998 6.92069 5.28551 6.79369 5.35343C6.6667 5.42135 6.55843 5.51957 6.4785 5.63938L6.42425 5.73388L5.313 7.95462C6.6675 8.36062 8.49275 8.75 10.5 8.75C12.3743 8.75 14.0884 8.4105 15.4088 8.03512L15.6861 7.95462L14.5758 5.73388C14.5114 5.60509 14.4162 5.49418 14.2986 5.411C14.1811 5.32781 14.0449 5.27491 13.902 5.257L13.7944 5.25H13.7935Z"
            fill="#712739"
          />
        </svg>
      );
    case UNFILLEDHEART:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="22"
          viewBox="0 0 24 22"
          fill="none"
        >
          <g filter="url(#filter0_d_6288_8)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 1.692C13.1712 0.606817 14.7083 0.00270081 16.305 0C18.031 0 19.679 0.71 20.885 1.96C22.0851 3.211 22.7536 4.87845 22.75 6.612C22.7536 8.34555 22.0851 10.013 20.885 11.264C20.089 12.089 19.294 12.934 18.495 13.782C16.871 15.506 15.23 17.249 13.525 18.89L13.522 18.894C13.0987 19.2949 12.5342 19.5125 11.9513 19.4996C11.3684 19.4867 10.8142 19.2443 10.409 18.825L3.11399 11.264C0.628994 8.687 0.628994 4.537 3.11399 1.961C4.2626 0.757408 5.83888 0.0544002 7.50182 0.00405884C9.16477 -0.0462825 10.7807 0.56009 12 1.692Z"
              fill="white"
              fill-opacity="0.5"
              shape-rendering="crispEdges"
            />
            <path
              d="M16.3049 0.5C17.8928 0.5 19.4122 1.15353 20.5256 2.30762V2.30664C21.6356 3.46417 22.2535 5.00761 22.2502 6.61133V6.61328C22.2535 8.21682 21.6354 9.75954 20.5256 10.917C19.7271 11.7446 18.9295 12.5921 18.1311 13.4395C16.5056 15.165 14.8726 16.8983 13.178 18.5293L13.1643 18.542C12.8381 18.8446 12.4075 19.0099 11.9622 19C11.5676 18.9912 11.1901 18.846 10.8918 18.5928L10.7688 18.4775L3.47388 10.917C1.17569 8.53372 1.17599 4.69087 3.47388 2.30859L3.67896 2.10352C4.71566 1.11903 6.08116 0.547395 7.51685 0.503906C9.04838 0.457543 10.5364 1.01617 11.6594 2.05859L11.9993 2.37402L12.3401 2.05859C13.4189 1.0592 14.8344 0.502716 16.3049 0.5Z"
              stroke="white"
              shape-rendering="crispEdges"
              fill="none"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_6288_8"
              x="-2.74976"
              y="0"
              width="29.4998"
              height="27.5002"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6288_8"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_6288_8"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case FILLEDHEART:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="22"
          viewBox="0 0 24 22"
          fill="none"
        >
          <g filter="url(#filter0_d_6288_33)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 1.692C13.1712 0.606817 14.7083 0.00270081 16.305 0C18.031 0 19.679 0.71 20.885 1.96C22.0851 3.211 22.7536 4.87845 22.75 6.612C22.7536 8.34555 22.0851 10.013 20.885 11.264C20.089 12.089 19.294 12.934 18.495 13.782C16.871 15.506 15.23 17.249 13.525 18.89L13.522 18.894C13.0987 19.2949 12.5342 19.5125 11.9513 19.4996C11.3684 19.4867 10.8142 19.2443 10.409 18.825L3.11399 11.264C0.628994 8.687 0.628994 4.537 3.11399 1.961C4.2626 0.757408 5.83888 0.0544002 7.50182 0.00405884C9.16477 -0.0462825 10.7807 0.56009 12 1.692Z"
              fill="#712739"
            />
            <path
              d="M16.3049 0.5C17.8928 0.5 19.4122 1.15353 20.5256 2.30762V2.30664C21.6356 3.46417 22.2535 5.00761 22.2502 6.61133V6.61328C22.2535 8.21682 21.6354 9.75954 20.5256 10.917C19.7271 11.7446 18.9295 12.5921 18.1311 13.4395C16.5056 15.165 14.8726 16.8983 13.178 18.5293L13.1643 18.542C12.8381 18.8446 12.4075 19.0099 11.9622 19C11.5676 18.9912 11.1901 18.846 10.8918 18.5928L10.7688 18.4775L3.47388 10.917C1.17569 8.53372 1.17599 4.69087 3.47388 2.30859L3.67896 2.10352C4.71566 1.11903 6.08116 0.547395 7.51685 0.503906C9.04838 0.457543 10.5364 1.01617 11.6594 2.05859L11.9993 2.37402L12.3401 2.05859C13.4189 1.0592 14.8344 0.502716 16.3049 0.5Z"
              stroke="white"
              fill="none"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_6288_33"
              x="-2.74976"
              y="0"
              width="29.4998"
              height="27.5002"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6288_33"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_6288_33"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );

    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

BrandIconCard.defaultProps = {
  className: null,
  rootClassName: null,
  type: 'default',
};

BrandIconCard.propTypes = {
  className: string,
  rootClassName: string,
  type: string,
};

export default BrandIconCard;
